export default "__VITE_ASSET__iZLQ8A01__"